import moment from 'moment';

import { TimePickerSchedule } from '../pickers';

export const availabilityPickerHeight = 350;

export const isScheduleWithTheSameTimeframe = (schedule1: TimePickerSchedule, schedule2: TimePickerSchedule) => {
  return (
    moment(schedule1.start).toISOString() === moment(schedule2.start).toISOString() &&
    moment(schedule1.end).toISOString() === moment(schedule2.end).toISOString()
  );
};

export const isSameSchedule = (schedule1: TimePickerSchedule, schedule2: TimePickerSchedule) => {
  return isScheduleWithTheSameTimeframe(schedule1, schedule2) && schedule1.resourceId === schedule2.resourceId;
};

export const getNextSchedule = (schedules: TimePickerSchedule[], chosenSchedule: TimePickerSchedule) => {
  return schedules.find(schedule => isScheduleWithTheSameTimeframe(chosenSchedule, schedule));
};

export const findNewSchedule = (schedules: TimePickerSchedule[], chosenSchedule: TimePickerSchedule) => {
  const foundMatchingSchedule = schedules.find(schedule => isScheduleWithTheSameTimeframe(chosenSchedule, schedule));

  // If the same schedule exists in newly fetched availabilities then return it and exit function
  // If the same schedule does NOT exist in newly fetched availabilities then return new one with the same timeframe

  if (foundMatchingSchedule) {
    return foundMatchingSchedule;
  }

  return null;
};
